import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useId } from "react";
import { useTranslation } from "react-i18next";

interface EvaluationRadioGroupProps {
  evaluationRate: number;
}

function EvaluationRadioGroup({ evaluationRate }: EvaluationRadioGroupProps) {
  const id = useId();
  const { t } = useTranslation();
  return (
    <RadioGroup
      className="mt-5 inline-flex gap-12"
      value={evaluationRate.toString()}
      disabled={true}
    >
      <div className=" flex flex-row space-x-4">
        <div className=" flex flex-row space-x-2">
          <RadioGroupItem id={`${id} 0`} value={"0"} />
          <label htmlFor={`${id} 0`}>{t("ineligible")}</label>
        </div>
        <div className=" flex flex-row border-l border-l-cool-gray-300 pl-4 space-x-4">
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem id={`${id} 1`} value={"1"} />
            <label htmlFor={`${id} 1`}>0%</label>
          </div>
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem id={`${id} 2`} value={"2"} />
            <label htmlFor={`${id} 2`}>50%</label>
          </div>
          <div className="flex flex-row space-x-2">
            <RadioGroupItem id={`${id} 3`} value={"3"} />
            <label htmlFor={`${id} 3`}>100%</label>
          </div>
        </div>
      </div>
    </RadioGroup>
  );
}

export default EvaluationRadioGroup;
